import script from "./BalTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalTable.vue?vue&type=script&setup=true&lang=ts"

import "./BalTable.vue?vue&type=style&index=0&id=bc99e55e&lang=css"

const __exports__ = script;

export default __exports__